<script setup>
import {defineEmits, defineProps} from "vue";

defineProps({
    loading: Boolean,
    disabled: Boolean,
    large: Boolean,
    color: String,
    icon: String,
    tooltip: String,
    classe: String,
});

const emit = defineEmits(["press"])

function press() {
    emit('press');
}
</script>

<template>
    <v-tooltip
        :disabled="!tooltip"
        right
    >
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                small
                icon
                :class="classe"
                :color="color"
                :loading="loading"
                :disabled="disabled"
                @click="press"
            >
                <v-icon>{{ icon }}</v-icon>
            </v-btn>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<style scoped>

</style>